<template>
  <div class="box">
    <div class="back" v-on:click="back">
      <img src="../assets/GoBack.png" alt />
    </div>
    <div class="title">问题反馈</div>
    <div class="TypeList">
      <div
        :class="'typeLi '+(indexs===index?'click':'')"
        v-on:click="clickContent(item,index)"
        v-for="(item,index) in QuestionList"
        :key="index"
      >{{item}}</div>
    </div>
    <div class="QuestionBox">
      <div>联系电话</div>
      <input type="text" name id placeholder="请输入联系电话" v-model="mobile" />
    </div>
    <div class="bottom" v-bind:class="{  'nav-hide': hideClass }">
      <div class="text">有任何问题需要联系我们，可留联系电话或者 把问题发送到xxx@163.com邮箱，我们尽快与您联系</div>
      <div class="btn" @click="submit">确认提交</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "box",
  data() {
    return {
      FeedbackList: [],
      QuestionList: "",
      indexs: "",
      content: "",
      mobile: "",

      // 默认屏幕高度
      docmHeight: document.documentElement.clientHeight, //一开始的屏幕高度
      showHeight: document.documentElement.clientHeight, //一开始的屏幕高度
      hideClass: false,

      flag:true
    };
  },
  components: {},
  created() {},
  mounted() {
    this.clientHeight = document.documentElement.clientHeight;
    const that = this;
    // 安卓手机键盘吊起挡住输入框

    window.onresize = () => {
      return (() => {
        window.screenHeight = document.body.clientHeight;
        this.showHeight = window.screenHeight;
      })();
    };

    var openid = localStorage.getItem("ZQopenid");
    var UserInfo = localStorage.getItem("ZQUserInfo")
      ? JSON.parse(localStorage.getItem("ZQUserInfo"))
      : "";
    var location = JSON.parse(localStorage.getItem("ZQlocation"));
    this.$store.commit("location", location ? location : {});
    this.$store.commit("UserInfo", {
      UserInfo: UserInfo
    });
    this.$store.commit(
      "UserSelf",
      JSON.parse(localStorage.getItem("ZQUserSelf"))
    );
    this.UserInfo = UserInfo;
    this.openid = UserInfo.openid;
    this.getQuestion();
  },
  methods: {
    clickContent(item, index) {
      if (index === this.indexs) {
        this.indexs = "";
        this.content = "";
      } else {
        this.indexs = index;
        this.content = item;
      }
    },
    back() {
      this.$router.go(-1);
    },
    getQuestion() {
      this.$http
        .get("/api/shop/get_stlist", {
          params: {}
        })
        .then(res => {
          this.QuestionList = res.data.data.action;
        });
    },
    submit() {
      console.log("dianji")
      if(!this.flag){
        return
      }
      if (this.content == "") {
        alert("请选择反馈内容");
        return;
      }
      if (this.mobile != "") {
        var ph = /^(0|86|17951)?(13[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|14[0-9]|19[0-9])[0-9]{8}$/;
        var mb = /^(0[0-9]{2,3}\-?)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/;
        if (!ph.test(this.mobile) && !mb.test(this.mobile)) {
          alert("手机号格式错误");
          return;
        }
      }
      this.flag=false
      this.$http
        .get("/api/shop/post_fankui", {
          params: {
            phone: this.mobile,
            content: this.content
          }
        })
        .then(res => {
          if (res.data.code == 1) {
            this.flag=true
            this.$store.commit("showMsg", {
              show: true,
              type: true,
              msg: "提交成功"
            }); //显示领取成功
            this.mobile = "";
            this.content = "";
            this.indexs = "";
          } else {
            this.flag=true
            this.$store.commit("showLoading", false); //关闭加载图标
            this.$store.commit("showMsg", {
              show: true,
              type: false,
              msg: res.data.msg
            }); //显示领取失败
          }
        });
    },

    // 检测屏幕高度变化
    inputType() {
      if (!this.timer) {
        this.timer = true;
        let that = this;
        setTimeout(() => {
          if (that.docmHeight > that.showHeight) {
            //显示class
            this.hideClass = true;
          } else if (that.docmHeight <= that.showHeight) {
            //显示隐藏
            this.hideClass = false;
          }
          that.timer = false;
        }, 20);
      }
    }
  },
  watch: {
    showHeight: "inputType"
  }
};
</script>
<style lang='scss' scoped>
.box {
  width: 7.5rem;
  height: 100vh;
  background: white;
}
input {
  background: none;
  outline: none;
  border: none;
  text-align: right;
}
input:focus {
  border: none;
}
.title {
  font-size: 0.32rem;
  line-height: 0.9rem;
  text-align: center;
  border-bottom: 1px solid #e5e5e5;
}
.back {
  position: absolute;
  top: 0.3rem;
  left: 0.2rem;
  width: 0.4rem;
  height: 0.4rem;
  z-index: 1000;
}
.back img {
  width: 100%;
  height: 100%;
  display: inline-block;
}
.QuestionBox {
  padding: 0.2rem;
  font-size: 0.28rem;
  background: #f5f5f5;
  margin: 0.3rem;
  margin-bottom: 0;
  border-radius: 0.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.TypeList {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  padding: 0.35rem;
}
.typeLi {
  margin-right: 0.15rem;
  line-height: 0.4rem;
  padding: 0.2rem;
  border: 1px solid #eeeeee;
  border-radius: 0.1rem;
  color: #636363;
  margin-bottom: 0.14rem;
}
.click {
  background: #cd160d;
  color: white !important;
  border-color: #cd160d !important;
}
.bottom {
  position: fixed;
  bottom: 0;
  left: 0;
}
.text {
  font-size: 0.24rem;
  color: #636363;
  line-height: 0.4rem;
  padding: 0 0.5rem;
  margin-bottom: 0.9rem;
}
.btn {
  color: white;
  font-size: 0.32rem;
  text-align: center;
  line-height: 1rem;
  height: 1rem;
  background: #cd160d;
}
.nav-hide {
  position: static !important;
}
</style>
